import { CoreMenu } from '@core/types'

export const menu: CoreMenu[] = [

  {
    id: "employee",
    title: "Analytics",
    translate: "MENU.DASHBOARD.analytics",
    type: "collapsible",
    icon: "bar-chart-2",
    children: [
   {
        id: "employee-list",
        title: "analytics",
        translate: "MENU.DASHBOARD.analytics",
        type: "item",
        icon: "circle",
        url: "analytics",
      },
    
    ],
  },
  {
    id: "employee",
    title: "Employees",
    translate: "MENU.DASHBOARD.employees",
    type: "collapsible",
    icon: "user-check",
    children: [
      {
        id: "avatars-list",
        title: "List",
        translate: "MENU.DASHBOARD.list",
        type: "item",
        icon: "circle",
        url: "employees",
      },
      {
        id: "employee-add",
        title: "Add",
        translate: "MENU.DASHBOARD.add",
        type: "item",
        icon: "circle",
        url: "add-employees", 
      },
    ],
  },
  {
    id: "job-title",
    title: "Job Title",
    translate: "MENU.DASHBOARD.employee_job_title",
    type: "collapsible",
    icon: "briefcase",
    children: [
      {
        id: "job-title-list",
        title: "List",
        translate: "MENU.DASHBOARD.list",
        type: "item",
        icon: "circle",
        url: "job-title",
      },
      {
        id: "job-title-add",
        title: "Add",
        translate: "MENU.DASHBOARD.add",
        type: "item",
        icon: "circle",
        url: "add-job-title", 
      },
    ],
  },
  {
    id: "avatars",
    title: "Investors",
    translate: "MENU.DASHBOARD.investors",
    type: "collapsible",
    icon: "dollar-sign",
    children: [
      {
        id: "avatars-list",
        title: "List",
        translate: "MENU.DASHBOARD.list",
        type: "item",
        icon: "circle",
        url: "investors",
      },
      {
        id: "avatars-add",
        title: "Add",
        translate: "MENU.DASHBOARD.add",
        type: "item",
        icon: "circle",
        url: "add-investors", 
      },
    ],
  },
  {
    id: "contracts",
    title: "Contracts",
    translate: "MENU.DASHBOARD.contracts",
    type: "collapsible",
    icon: "file-text",
    children: [
      {
        id: "avatars-list",
        title: "List",
        translate: "MENU.DASHBOARD.list",
        type: "item",
        icon: "circle",
        url: "contracts",
      },
      {
        id: "avatars-add",
        title: "Add",
        translate: "MENU.DASHBOARD.add",
        type: "item",
        icon: "circle",
        url: "add-contracts", 
      },
    ],
  },
  {
    id: "contracts",
    title: "Contracts",
    translate: "MENU.DASHBOARD.NEWS",
    type: "collapsible",
    icon: "bookmark",
    children: [
      {
        id: "avatars-list",
        title: "List",
        translate: "MENU.DASHBOARD.list",
        type: "item",
        icon: "circle",
        url: "news",
      },
      {
        id: "avatars-add",
        title: "Add",
        translate: "MENU.DASHBOARD.add",
        type: "item",
        icon: "circle",
        url: "add-news", 
      },
    ],
  },
  {
    id: "contracts",
    title: "Contracts",
    translate: "MENU.DASHBOARD.TEAM_MEMBERS",
    type: "collapsible",
    icon: "users",
    children: [
      {
        id: "avatars-list",
        title: "List",
        translate: "MENU.DASHBOARD.list",
        type: "item",
        icon: "circle",
        url: "team-members",
      },
      {
        id: "avatars-add",
        title: "Add",
        translate: "MENU.DASHBOARD.add",
        type: "item",
        icon: "circle",
        url: "add-team-members", 
      },
    ],
  },
  {
    id: "contracts",
    title: "OuRMessages",
    translate: "MENU.DASHBOARD.our_messages",
    type: "collapsible",
    icon: "message-circle",
    children: [
      {
        id: "avatars-list",
        title: "List",
        translate: "MENU.DASHBOARD.list",
        type: "item",
        icon: "circle",
        url: "our-message",
      },
      // {
      //   id: "avatars-add",
      //   title: "Add",
      //   translate: "MENU.DASHBOARD.add",
      //   type: "item",
      //   icon: "circle",
      //   url: "add-our-message", 
      // },
    ],
  },
  {
    id: "contracts",
    title: "reports",
    translate: "MENU.DASHBOARD.reports",
    type: "collapsible",
    icon: "file-text",
    children: [
      {
        id: "avatars-list",
        title: "List",
        translate: "MENU.DASHBOARD.list",
        type: "item",
        icon: "circle",
        url: "reports",
      },
      {
        id: "avatars-add",
        title: "Add",
        translate: "MENU.DASHBOARD.add",
        type: "item",
        icon: "circle",
        url: "add-reports", 
      },
    ],
  },
  {
    id: "contracts",
    title: "Contracts",
    translate: "MENU.DASHBOARD.SECTORS",
    type: "collapsible",
    icon: "rss",
    children: [
      {
        id: "avatars-list",
        title: "List",
        translate: "MENU.DASHBOARD.list",
        type: "item",
        icon: "circle",
        url: "sectors",
      },
      {
        id: "avatars-add",
        title: "Add",
        translate: "MENU.DASHBOARD.add",
        type: "item",
        icon: "circle",
        url: "add-sectors", 
      },
    ],
  },
  {
    id: "contracts",
    title: "Vision KSA",
    translate: "MENU.DASHBOARD.vision-ksa",
    type: "collapsible",
    icon: "eye",
    children: [
      {
        id: "avatars-list",
        title: "List",
        translate: "MENU.DASHBOARD.list",
        type: "item",
        icon: "circle",
        url: "vision-ksa",
      },
      {
        id: "avatars-add",
        title: "Add",
        translate: "MENU.DASHBOARD.add",
        type: "item",
        icon: "circle",
        url: "add-vision-ksa", 
      },
    ],
  },
  {
    id: "payments",
    title: "payments",
    translate: "MENU.DASHBOARD.payments",
    type: "collapsible",
    icon: "credit-card",
    children: [
      {
        id: "avatars-list",
        title: "List",
        translate: "MENU.DASHBOARD.list",
        type: "item",
        icon: "circle",
        url: "payments",
      },
      // {
      //   id: "avatars-add",
      //   title: "Add",
      //   translate: "MENU.DASHBOARD.add",
      //   type: "item",
      //   icon: "circle",
      //   url: "add-payments", 
      // },
    ],
  },
  {
    id: "contract-type",
    title: "ContractsType",
    translate: "MENU.DASHBOARD.contract_type",
    type: "collapsible",
    icon: "layers",
    children: [
      {
        id: "avatars-lisst",
        title: "List",
        translate: "MENU.DASHBOARD.list",
        type: "item",
        icon: "circle",
        url: "contracts-type",
      },
      {
        id: "avatars-addd",
        title: "Add",
        translate: "MENU.DASHBOARD.add",
        type: "item",
        icon: "circle",
        url: "add-contracts-type", 
      },
    ],
  },
  {
    id: "countries",
    title: "countries",
    translate: "MENU.DASHBOARD.countries",
    type: "collapsible",
    icon: "globe",
    children: [
      {
        id: "countries",
        title: "List",
        translate: "MENU.DASHBOARD.list",
        type: "item",
        icon: "circle",
        url: "m-countries",
      },
      {
        id: "add-countries",
        title: "Add",
        translate: "MENU.DASHBOARD.add",
        type: "item",
        icon: "circle",
        url: "add-new-m-countries", 
      },
    ],
  },
   {
    id: "cities",
    title: "Cities",
    translate: "MENU.DASHBOARD.cities",
    type: "collapsible",
    icon: "layers",
    children: [
      {
        id: "cities",
        title: "List",
        translate: "MENU.DASHBOARD.list",
        type: "item",
        icon: "circle",
        url: "m-cities",
      },
      {
        id: "add-cities",
        title: "Add",
        translate: "MENU.DASHBOARD.add",
        type: "item",
        icon: "circle",
        url: "add-new-m-cities", 
      },
    ],
  },
    {
    id: "chat",
    title: "chat",
    translate: "MENU.DASHBOARD.chat",
    type: "collapsible",
    icon: "navigation",
    children: [
      {
        id: "chat",
        title: "List",
        translate: "MENU.DASHBOARD.list",
        type: "item",
        icon: "circle",
        url: "chats",
      },
     
    ],
  },
  
  {
    id: "avatars",
    title: "Alerts",
    translate: "MENU.DASHBOARD.alerts",
    type: "collapsible",
    icon: "bell",
    children: [
      {
        id: "alerts",
        title: "List",
        translate: "MENU.DASHBOARD.list",
        type: "item",
        icon: "circle",
        url: "alerts",
      },
      {
        id: "alerts-add",
        title: "Add",
        translate: "MENU.DASHBOARD.add",
        type: "item",
        icon: "circle",
        url: "add-alerts", 
      },
    ],
  },
  
 
 
 
 
      {
    id: "settings",
    title: "Settings",
    translate: "MENU.DASHBOARD.Settings",
    type: "collapsible", // Allows the menu to be clickable and expandable
    icon: "settings",
    children: [


  {
    id: "Partners",
    title: "About Miracle",
    translate: "MENU.DASHBOARD.about_miracle",
    type: "collapsible",
    icon: "info",
    children: [
      {
        id: "Partners-list",
        title: "List",
        translate: "MENU.DASHBOARD.list",
        type: "item",
        icon: "circle",
        url: "new-about",
      },
     
    ],
  },
  // {
  //   id: "avatars",
  //   title: "Vision & Mission",
  //   translate: "MENU.DASHBOARD.VISION_MISSIONtitle",
  //   type: "collapsible",
  //   icon: "target",
  //   children: [
  //     {
  //       id: "avatars-list",
  //       title: "List",
  //       translate: "MENU.DASHBOARD.list",
  //       type: "item",
  //       icon: "circle",
  //       url: "aboutt",
  //     },
    
  //   ],
  // },
   {
    id: "Partners",
    title: "Partners",
    translate: "MENU.DASHBOARD.partners",
    type: "collapsible",
    icon: "users",
    children: [
      {
        id: "Partners-list",
        title: "List",
        translate: "MENU.DASHBOARD.list",
        type: "item",
        icon: "circle",
        url: "partners",
      },
      {
        id: "Partners-add",
        title: "Add Partners",
        translate: "MENU.DASHBOARD.add",
        type: "item",
        icon: "circle",
        url: "partners-add", 
      },
    ],
  },
  {
    id: "avatars",
    title: "FAQ",
    translate: "MENU.DASHBOARD.faq",
    type: "collapsible",
    icon: "help-circle",
    children: [
      {
        id: "avatars-list",
        title: "List",
        translate: "MENU.DASHBOARD.list",
        type: "item",
        icon: "circle",
        url: "frequently",
      },
      {
        id: "avatars-add",
        title: "Add",
        translate: "MENU.DASHBOARD.add",
        type: "item",
        icon: "circle",
        url: "add-faqs", 
      },
    ],
  },
  
   {
    id: "avatars",
    title: "Privacy policy",
    translate: "MENU.DASHBOARD.privacy_policy",
    type: "collapsible",
    icon: "shield",
    children: [
      {
        id: "avatars-list",
        title: "List",
        translate: "MENU.DASHBOARD.list",
        type: "item",
        icon: "circle",
        url: "privacy",
      },
    ]
  },

 
   {
    id: "avatars",
    title: "Terms ",
    translate: "MENU.DASHBOARD.terms",
    type: "collapsible",
    icon: "file",
    children: [
      {
        id: "avatars-list",
        title: "List",
        translate: "MENU.DASHBOARD.list",
        type: "item",
        icon: "circle",
        url: "miracle-terms",
      },
     
    ],
  },
 
   {
    id: "avatars",
    title: "Contact Us ",
    translate: "MENU.DASHBOARD.contact_us",
    type: "collapsible",
    icon: "phone",
    children: [
      {
        id: "avatars-list",
        title: "List",
        translate: "MENU.DASHBOARD.list",
        type: "item",
        icon: "circle",
        url: "new-contact-us",
      },
     
    ],
  },
 
   {
    id: "avatars",
    title: "Delete account",
    translate: "MENU.DASHBOARD.titlee",
    type: "collapsible",
    icon: "trash",
    children: [
      {
        id: "avatars-list",
        title: "List",
        translate: "MENU.DASHBOARD.list",
        type: "item",
        icon: "circle",
        url: "delete-account",
      },
     
    ],
  },
    ]
  },


  // {
  //   id: "private",
  //   title: "Auth Privacy",
  //   translate: "MENU.DASHBOARD.no_auth_privacy_policy",
  //   type: "collapsible",
  //   icon: "info",
  //   children: [
  //     {
  //       id: "priv",
  //       title: "List",
  //       translate: "MENU.DASHBOARD.list",
  //       type: "item",
  //       icon: "circle",
  //       url: "auth-privacy"
  //     }
  //   ]
  // },
  //    {
  //   id: "avatars",
  //   title: "No Auth Privacy policy",
  //   translate: "MENU.DASHBOARD.no_auth_privacy_policy",
  //   type: "collapsible",
  //   icon: "info",
  //   children: [
  //     {
  //       id: "avatars-list",
  //       title: "List",
  //       translate: "MENU.DASHBOARD.list",
  //       type: "item",
  //       icon: "circle",
  //       url: "auth-privacy",
  //     },
  //   ]
  // }

  // {
  //   id: "avatars",
  //   title: "Ads",
  //   translate:  "MENU.DASHBOARD.ads",
  //   type: "collapsible" ,
  //   icon: "image", 
  //   children: [
  //     {
  //       id: "avatars-list",
  //       title: "List",
  //       translate: "MENU.DASHBOARD.list",
  //       type: "item",
  //       icon: "circle",
  //       url: "ads",
  //     },
  //     {
  //       id: "avatars-add",
  //       title: "Add",
  //       translate: "MENU.DASHBOARD.add",
  //       type: "item",
  //       icon: "circle",
  //       url: "add-ads",
  //     },
  //   ],
  // },
  // {
  //   id: "avatars",
  //   title: "Counselors",
  //   translate:  "MENU.DASHBOARD.counselors",
  //   type: "collapsible",
  //   icon: "package",
  //   children: [
  //     {
  //       id: "avatars-list",
  //       title: "List",
  //       translate: "Stores",
  //       type: "item",
  //       icon: "circle",
  //       url: "counselors",
  //     },
  //     {
  //       id: "avatars-add",
  //       title: "Add",
  //       translate: "MENU.DASHBOARD.add",
  //       type: "item",
  //       icon: "circle",
  //       url: "add-counselors",
  //     },
  //   ],
  // },
  // {
  //   id: "avatars",
  //   title: "Stores Offers",
  //   translate:  "MENU.DASHBOARD.stores_offers",
  //   type: "collapsible",
  //   icon: "dollar-sign",
  //   children: [
  //     {
  //       id: "avatars-list",
  //       title: "List",
  //       translate: "Vouchers",
  //       type: "item",
  //       icon: "circle",
  //       url: "StoresOffers-Vouchers",
  //     },
  //     {
  //       id: "avatars-add",
  //       title: "Add",
  //       translate: "MENU.DASHBOARD.add",
  //       type: "item",
  //       icon: "circle",
  //       url: "StoresOffers-add",
  //     },
  //   ],
  // },
  // {
  //   id: "avatars",
  //   title: "Cancelation Reason",
  //   translate:  "MENU.DASHBOARD.cancelation_reason",
  //   type: "collapsible",
  //   icon: "tablet",
  //   children: [
  //     {
  //       id: "avatars-list",
  //       title: "List",
  //       translate: "MENU.DASHBOARD.list",
  //       type: "item",
  //       icon: "circle",
  //       url: "CancelationReasons",
  //     },
  //     {
  //       id: "avatars-add",
  //       title: "Add",
  //       translate: "MENU.DASHBOARD.add",
  //       type: "item",
  //       icon: "circle",
  //       url: "CancelationReasons-add",
  //     },
  //   ],
  // },
  // {
  //   id: "avatars",
  //   title: "Companies",
  //   translate:  "MENU.DASHBOARD.companies",
  //   type: "collapsible",
  //   icon: "hexagon",
  //   children: [
  //     {
  //       id: "avatars-list",
  //       title: "List",
  //       translate: "MENU.DASHBOARD.list",
  //       type: "item",
  //       icon: "circle",
  //       url: "Companies",
  //     },
  //     {
  //       id: "avatars-add",
  //       title: "Add",
  //       translate: "MENU.DASHBOARD.add",
  //       type: "item",
  //       icon: "circle",
  //       url: "Companies-add",
  //     },
  //   ],
  // },
  // {
  //   id: "avatars",
  //   title: "Consulting",
  //   translate:  "MENU.DASHBOARD.consulting",
  //   type: "collapsible",
  //   icon: "credit-card",
  //   children: [
  //     {
  //       id: "avatars-list",
  //       title: "List",
  //       translate: "MENU.DASHBOARD.list",
  //       type: "item",
  //       icon: "circle",
  //       url: "Consulting",
  //     },
  //     {
  //       id: "avatars-add",
  //       title: "Add",
  //       translate: "MENU.DASHBOARD.add",
  //       type: "item",
  //       icon: "circle",
  //       url: "Consulting-add",
  //     },
  //   ],
  // },
  // {
  //   id: "avatars",
  //   title: "Categories",
  //   translate:  "MENU.DASHBOARD.categories",
  //   type: "collapsible",
  //   icon: "percent",
  //   children: [
  //     {
  //       id: "avatars-list",
  //       title: "List",
  //       translate: "MENU.DASHBOARD.list",
  //       type: "item",
  //       icon: "circle",
  //       url: "Categories",
  //     },
  //     {
  //       id: "avatars-add",
  //       title: "Add",
  //       translate: "MENU.DASHBOARD.add",
  //       type: "item",
  //       icon: "circle",
  //       url: "Categories-add",
  //     },
  //   ],
  // },
  // {
  //   id: "avatars",
  //   title: "Services",
  //   translate:  "MENU.DASHBOARD.services",
  //   type: "collapsible",
  //   icon: "map-pin",
  //   children: [
  //     {
  //       id: "avatars-list",
  //       title: "List",
  //       translate: "MENU.DASHBOARD.list",
  //       type: "item",
  //       icon: "circle",
  //       url: "Services",
  //     },
  //     {
  //       id: "avatars-add",
  //       title: "Add",
  //       translate: "MENU.DASHBOARD.add",
  //       type: "item",
  //       icon: "circle",
  //       url: "Services-add",
  //     },
  //   ],
  // },
  // {
  //   id: "avatars",
  //   title: "Tags",
  //   translate:  "MENU.DASHBOARD.tags",
  //   type: "collapsible",
  //   icon: "video",
  //   children: [
  //     {
  //       id: "avatars-list",
  //       title: "List",
  //       translate: "MENU.DASHBOARD.list",
  //       type: "item",
  //       icon: "circle",
  //       url: "Tags",
  //     },
  //     {
  //       id: "avatars-add",
  //       title: "Add",
  //       translate: "MENU.DASHBOARD.add",
  //       type: "item",
  //       icon: "circle",
  //       url: "Tags-add",
  //     },
  //   ],
  // },
  // {
  //   id: "avatars",
  //   title: "Articles",
  //   translate:  "MENU.DASHBOARD.articles",
  //   type: "collapsible",
  //   icon: "upload",
  //   children: [
  //     {
  //       id: "avatars-list",
  //       title: "List",
  //       translate: "MENU.DASHBOARD.list",
  //       type: "item",
  //       icon: "circle",
  //       url: "Articles",
  //     },
  //     {
  //       id: "avatars-add",
  //       title: "Add",
  //       translate: "MENU.DASHBOARD.add",
  //       type: "item",
  //       icon: "circle",
  //       url: "Articles-add",
  //     },
  //   ],
  // },
  // {
  //   id: "avatars",
  //   title: "Offers",
  //   translate: "MENU.DASHBOARD.offers",
  //   type: "collapsible",
  //   icon: "settings",
  //   children: [
  //     {
  //       id: "avatars-list",
  //       title: "List",
  //       translate: "MENU.DASHBOARD.list",
  //       type: "item",
  //       icon: "circle",
  //       url: "Offers",
  //     },
  //     {
  //       id: "avatars-add",
  //       title: "Add",
  //       translate: "MENU.DASHBOARD.add",
  //       type: "item",
  //       icon: "circle",
  //       url: "Offers-add",
  //     },
  //   ],
  // },
  // {
  //   id: "avatars",
  //   title: "Plant Cards",
  //   translate:  "MENU.DASHBOARD.plantcards",
  //   type: "collapsible",
  //   icon: "flag",
  //   children: [
  //     {
  //       id: "avatars-list",
  //       title: "List",
  //       translate: "MENU.DASHBOARD.list",
  //       type: "item",
  //       icon: "circle",
  //       url: "planetCards",
  //     },
  //     {
  //       id: "avatars-add",
  //       title: "Add",
  //       translate: "MENU.DASHBOARD.add",
  //       type: "item",
  //       icon: "circle",
  //       url: "planetCards-add",
  //     },
  //   ],
  // },
 
  
  //     {
  //       id: "terms-and-conditions",
  //       title: "Terms & Conditions",
  //       translate: "MENU.DASHBOARD.TermsAndConditions",
  //       type: "collapsible", // Expandable item with children
  //       icon: "lock",
  //       children: [
  //         {
  //           id: "terms-show-details",
  //           title: "Show Details",
  //           translate: "MENU.DASHBOARD.ShowDetails",
  //           type: "item",
  //           icon: "circle",
  //           url: "terms-conditions",
  //         },
  //       ],
  //     },
  //     {
  //       id: "terms-and-conditions",
  //       title: "About",
  //       translate: "MENU.DASHBOARD.About",
  //       type: "collapsible", // Expandable item with children
  //       icon: "file-text",
  //       children: [
  //         {
  //           id: "terms-show-details",
  //           title: "Show Details",
  //           translate: "MENU.DASHBOARD.ShowDetails",
  //           type: "item",
  //           icon: "circle",
  //           url: "about",
  //         },
  //       ],
  //     },
  //     {
  //       id: "terms-and-conditions",
  //       title: "Notifications",
  //       translate: "MENU.DASHBOARD.Notifications",
  //       type: "collapsible", // Expandable item with children
  //       icon: "shuffle",
  //       children: [
  //         {
  //           id: "terms-show-details",
  //           title: "Show Details",
  //           translate: "MENU.DASHBOARD.ShowDetails",
  //           type: "item",
  //           icon: "circle",
  //           url: "Notifications",
  //         },
  //       ],
  //     },
  //     {
  //       id: "terms-and-conditions",
  //       title: "Currencies",
  //       translate: "MENU.DASHBOARD.Currencies",
  //       type: "collapsible", // Expandable item with children
  //       icon: "package",
  //       children: [
  //         {
  //           id: "avatars-list",
  //           title: "List",
  //           translate: "MENU.DASHBOARD.list",
  //           type: "item",
  //           icon: "circle",
  //           url: "currencies",
  //         },
  //         {
  //           id: "avatars-add",
  //           title: "Add",
  //           translate: "MENU.DASHBOARD.add",
  //           type: "item",
  //           icon: "circle",
  //           url: "curriences-add",
  //         },
  //       ],
  //     },
  //     {
  //       id: "terms-and-conditions",
  //       title: "Countries",
  //       translate: "MENU.DASHBOARD.Countries",
  //       type: "collapsible", // Expandable item with children
  //       icon: "gift",
  //       children: [
  //         {
  //           id: "avatars-list",
  //           title: "List",
  //           translate: "MENU.DASHBOARD.list",
  //           type: "item",
  //           icon: "circle",
  //           url: "countries",
  //         },
  //         {
  //           id: "avatars-add",
  //           title: "Add",
  //           translate: "MENU.DASHBOARD.add",
  //           type: "item",
  //           icon: "circle",
  //           url: "countries-add",
  //         },
  //       ],
  //     },
  //     {
  //       id: "terms-and-conditions",
  //       title: "Cities",
  //       translate: "MENU.DASHBOARD.Cities",
  //       type: "collapsible", // Expandable item with children
  //       icon: "grid",
  //       children: [
  //         {
  //           id: "avatars-list",
  //           title: "List",
  //           translate: "MENU.DASHBOARD.list",
  //           type: "item",
  //           icon: "circle",
  //           url: "cities",
  //         },
  //         {
  //           id: "avatars-add",
  //           title: "Add",
  //           translate: "MENU.DASHBOARD.add",
  //           type: "item",
  //           icon: "circle",
  //           url: "cities-add",
  //         },
  //       ],
  //     },
  //     {
  //       id: "terms-and-conditions",
  //       title: "Language.plans",
  //       translate: "MENU.DASHBOARD.plans",
  //       type: "collapsible", // Expandable item with children
  //       icon: "calendar",
  //       children: [
  //         {
  //           id: "avatars-list",
  //           title: "List",
  //           translate: "MENU.DASHBOARD.list",
  //           type: "item",
  //           icon: "circle",
  //           url: "plans",
  //         },
  //         {
  //           id: "avatars-add",
  //           title: "Add",
  //           translate: "MENU.DASHBOARD.add",
  //           type: "item",
  //           icon: "circle",
  //           url: "languagePlans-add",
  //         },
  //       ],
  //     },
  //     {
  //       id: "terms-and-conditions",
  //       title: "Open Screens",
  //       translate: "MENU.DASHBOARD.OpenScreens",
  //       type: "collapsible", // Expandable item with children
  //       icon: "video",
  //       children: [
  //         {
  //           id: "avatars-list",
  //           title: "List",
  //           translate: "MENU.DASHBOARD.list",
  //           type: "item",
  //           icon: "circle",
  //           url: "open-screen",
  //         },
  //         {
  //           id: "avatars-add",
  //           title: "Add",
  //           translate: "MENU.DASHBOARD.add",
  //           type: "item",
  //           icon: "circle",
  //           url: "openScreens-add",
  //         },
  //       ],
  //     },
  //     {
  //       id: "terms-and-conditions",
  //       title: "Language.light",
  //       translate: "MENU.DASHBOARD.light",
  //       type: "collapsible", // Expandable item with children
  //       icon: "list",
  //       children: [
  //         {
  //           id: "avatars-list",
  //           title: "List",
  //           translate: "MENU.DASHBOARD.list",
  //           type: "item",
  //           icon: "circle",
  //           url: "light",
  //         },
  //         {
  //           id: "avatars-add",
  //           title: "Add",
  //           translate: "MENU.DASHBOARD.add",
  //           type: "item",
  //           icon: "circle",
  //           url: "languageLight-add",
  //         },
  //       ],
  //     },
  //     {
  //       id: "terms-and-conditions",
  //       title: "Ganatak community",
  //       translate: "MENU.DASHBOARD.GanatakCommunity",
  //       type: "collapsible", // Expandable item with children
  //       icon: "help-circle",
  //       children: [
  //         {
  //           id: "avatars-list",
  //           title: "List",
  //           translate: "MENU.DASHBOARD.list",
  //           type: "item",
  //           icon: "circle",
  //           url: "ganatak",
  //         },
  //         {
  //           id: "avatars-add",
  //           title: "Add",
  //           translate: "MENU.DASHBOARD.add",
  //           type: "item",
  //           icon: "circle",
  //           url: "ganatakCommunity-add",
  //         },
  //       ],
  //     },
  //     {
  //       id: "terms-and-conditions",
  //       title: "language.root",
  //       translate: "MENU.DASHBOARD.root",
  //       type: "collapsible", // Expandable item with children
  //       icon: "paperclip",
  //       children: [
  //         {
  //           id: "avatars-list",
  //           title: "List",
  //           translate: "MENU.DASHBOARD.list",
  //           type: "item",
  //           icon: "circle",
  //           url: "root",
  //         },
  //         {
  //           id: "avatars-add",
  //           title: "Add",
  //           translate: "MENU.DASHBOARD.add",
  //           type: "item",
  //           icon: "circle",
  //           url: "languageRoot-add",
  //         },
  //       ],
  //     },
  //     {
  //       id: "terms-and-conditions",
  //       title: "language.seed",
  //       translate: "MENU.DASHBOARD.seed",
  //       type: "collapsible", // Expandable item with children
  //       icon: "check-square",
  //       children: [
  //         {
  //           id: "avatars-list",
  //           title: "List",
  //           translate: "MENU.DASHBOARD.list",
  //           type: "item",
  //           icon: "circle",
  //           url: "seed",
  //         },
  //         {
  //           id: "avatars-add",
  //           title: "Add",
  //           translate: "MENU.DASHBOARD.add",
  //           type: "item",
  //           icon: "circle",
  //           url: "languageSeed-add",
  //         },
  //       ],
  //     },
  //     {
  //       id: "terms-and-conditions",
  //       title: "language.soil",
  //       translate: "MENU.DASHBOARD.soil",
  //       type: "collapsible", // Expandable item with children
  //       icon: "file-text",
  //       children: [
  //         {
  //           id: "avatars-list",
  //           title: "List",
  //           translate: "MENU.DASHBOARD.list",
  //           type: "item",
  //           icon: "circle",
  //           url: "soil",
  //         },
  //         {
  //           id: "avatars-add",
  //           title: "Add",
  //           translate: "MENU.DASHBOARD.add",
  //           type: "item",
  //           icon: "circle",
  //           url: "languageSoil-add",
  //         },
  //       ],
  //     },
  //     {
  //       id: "terms-and-conditions",
  //       title: "language.stem",
  //       translate: "MENU.DASHBOARD.stem",
  //       type: "collapsible", // Expandable item with children
  //       icon: "bookmark",
  //       children: [
  //         {
  //           id: "avatars-list",
  //           title: "List",
  //           translate: "MENU.DASHBOARD.list",
  //           type: "item",
  //           icon: "circle",
  //           url: "stem",
  //         },
  //         {
  //           id: "avatars-add",
  //           title: "Add",
  //           translate: "MENU.DASHBOARD.add",
  //           type: "item",
  //           icon: "circle",
  //           url: "languageStem-add",
  //         },
  //       ],
  //     },
  //     {
  //       id: "terms-and-conditions",
  //       title: "Paperform",
  //       translate: "MENU.DASHBOARD.Paperform",
  //       type: "collapsible", // Expandable item with children
  //       icon: "book",
  //       children: [
  //         {
  //           id: "avatars-list",
  //           title: "List",
  //           translate: "MENU.DASHBOARD.list",
  //           type: "item",
  //           icon: "circle",
  //           url: "paperform",
  //         },
  //         {
  //           id: "avatars-add",
  //           title: "Add",
  //           translate: "MENU.DASHBOARD.add",
  //           type: "item",
  //           icon: "circle",
  //           url: "paperForm-add",
  //         },
  //       ],
  //     },
  //     {
  //       id: "terms-and-conditions",
  //       title: "Sizes",
  //       translate: "MENU.DASHBOARD.Sizes",
  //       type: "collapsible", // Expandable item with children
  //       icon: "book-open",
  //       children: [
  //         {
  //           id: "avatars-list",
  //           title: "List",
  //           translate: "MENU.DASHBOARD.list",
  //           type: "item",
  //           icon: "circle",
  //           url: "sizes",
  //         },
  //         {
  //           id: "avatars-add",
  //           title: "Add",
  //           translate: "MENU.DASHBOARD.add",
  //           type: "item",
  //           icon: "circle",
  //           url: "sizes-add",
  //         },
  //       ],
  //     },
  //     {
  //       id: "terms-and-conditions",
  //       title: "Language.counselorspayment",
  //       translate: "MENU.DASHBOARD.counselorspayment",
  //       type: "collapsible", // Expandable item with children
  //       icon: "bar-chart-2",
  //       children: [
  //         {
  //           id: "avatars-list",
  //           title: "List",
  //           translate: "MENU.DASHBOARD.list",
  //           type: "item",
  //           icon: "circle",
  //           url: "counselorPayment",
  //         },
  //         {
  //           id: "avatars-add",
  //           title: "Add",
  //           translate: "MENU.DASHBOARD.add",
  //           type: "item",
  //           icon: "circle",
  //           url: "languageConsulers-add",
  //         },
  //       ],
  //     },
  //     {
  //       id: "terms-and-conditions",
  //       title: "Sliders",
  //       translate: "MENU.DASHBOARD.Sliders",
  //       type: "collapsible", // Expandable item with children
  //       icon: "sliders",
  //       children: [
  //         {
  //           id: "avatars-list",
  //           title: "List",
  //           translate: "MENU.DASHBOARD.list",
  //           type: "item",
  //           icon: "circle",
  //           url: "sliders",
  //         },
  //         {
  //           id: "avatars-add",
  //           title: "Add",
  //           translate: "MENU.DASHBOARD.add",
  //           type: "item",
  //           icon: "circle",
  //           url: "sliders-add",
  //         },
  //       ],
  //     },


  //   ],
  // },
 


    
]
